import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AdminAuthService } from 'app/admin/admin-auth.service';
import { OpenDialogYesOrNo } from '../dialog-yes-or-no/dialog-yes-or-no.component';
import * as constants from "../../constant";
import * as popupText from "../../mp-popup-message";
import { chownSync } from 'fs';

@Component({
  selector: 'wl-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss']
})
export class ResetpasswordComponent implements OnInit {
  resetOTPForm: UntypedFormGroup;
  verifyOTPForm: UntypedFormGroup;
  updatePasswordForm: UntypedFormGroup;
  verifyOTP: boolean = false
  sendOTP: boolean = true;
  changePassword: boolean = false
  temp: any;
  resendNotice: boolean = false;
  count: number = 0;
  countNew: number = 0;
  currentPasswordString:string= "Enter current Password";
  loading: boolean = false;

  constructor(private adminAuth: AdminAuthService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private dialog: MatDialog) {
    this.resetOTPForm = this.fb.group({
      staffId: ['', Validators.required],
    })
    this.verifyOTPForm = this.fb.group({
      otp: ['', Validators.required],
    })
    this.updatePasswordForm = this.fb.group({
      changePassword: ['', [Validators.required,Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9])[\S]{8,24}$/)]],
      confirmPassword: ['', Validators.required]
    }, { validator: this.checkIfMatchingPasswords('changePassword', 'confirmPassword') })

  }

  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: UntypedFormGroup) => {
      let passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({ notEquivalent: true })
      }
      else {
        console.log('password is correct')
        return passwordConfirmationInput.setErrors(null);

      }
    }
  }


  ngOnInit() {
  }

  sendUserOTP(staffId) {
    this.temp = staffId;
    console.log('staffid start', staffId);
    this.adminAuth.storeStaffId = (staffId.staffId);
    // sessionStorage.setItem('storeStaffId',staffId)
    console.log(this.adminAuth.storeStaffId);
    this.adminAuth.requestOtp(staffId).subscribe(res => {
      console.log('getotp', res);
      if (res.success == true) {
        this.verifyOTP = true;
        this.sendOTP = false;
      }
      else if (res.message == 'Staff Id not registered') {
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: {
            content1: popupText.STAFF_ID_NOT_REGISTERED,
            button1Text: "OK",
          }
        });
      }
      else if (res.message == 'OTP request limit exceed') {
        this.resendNotice = false
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: {
            content1: popupText.OTP_LIMIT_EXCEEDED,
            button1Text: "OK",
          }
        });
        dialogRef.afterClosed().subscribe(res => {
          console.log(res)
          if (res == "dontClose") {
            this.router.navigate(['/login-admin']);
          } else {

          }
        })

      }

    }

    )
    this.countNew++
    console.log('count', this.countNew)
    if (this.countNew < 4) {
      this.resendNotice = true;
    }
    setTimeout(() => {
      this.resendNotice = false;
    }, 3000);
  }


  resendOTP() {
    let staffId = this.temp;
    console.log('getid', staffId)
    this.sendUserOTP(staffId)
    this.count++
    console.log('count', this.count)
    if (this.count < 3) {
      this.resendNotice = true;
    }

    setTimeout(() => {
      this.resendNotice = false;
    }, 3000);

  }

  verifyUserOTP(value) {
    let getStaffId = this.adminAuth.storeStaffId;
    console.log('getid', getStaffId)
    value = {
      ...value,
      staffId: getStaffId
    }
    console.log('check value', value);
    this.adminAuth.verifyUserOtp(value).subscribe(res => {
      console.log('verifyotp', res);
      if (res.message == 'OTP Verified') {
        this.verifyOTP = false;
        this.sendOTP = false;
        this.changePassword = true;
      }
      else if (res.message == 'Invalid OTP') {
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: {
            content1: constants.INVALID_OTP,
            button1Text: "OK",
          }
        });
      }
      else if (res.message == 'OTP is expired') {
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: {
            content1: constants.OTP_EXPIRED,
            button1Text: "OK",

          }
        });
      }
    }
    )
  }

  resetPassword(value) {
    this.loading = true;
    let prd = value.changePassword;
    console.log('temp', prd);
    let getStaffId = this.adminAuth.storeStaffId;
    console.log('getid reset', getStaffId);
    // let oldPrd = this.updatePasswordForm.value.oldPrd;
    value = {
      prd, staffId: getStaffId, type:"forgot"
    }
    console.log('final', value);
    this.adminAuth.setNewPassword(value).subscribe(res => {
      console.log('final');
      this.loading = false;
      if (res.message == 'Password Updated Successfully' || res.message == 'Password Deleted and Updated Successfully') {
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: {
            content1: constants.PASSWORD_UPDATED_SUCCESSFULLY,
            button1Text: "OK",
          }
        });
        dialogRef.afterClosed().subscribe(res => {
          console.log(res)
          if (res == "dontClose") {
            this.router.navigate(['/login-admin']);
          } else {

          }
        })
      }else
      if (res.message == 'Password Already exist') {
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: {
            content1: constants.PASSWORD_ALREADY_EXISTS,
            button1Text: "OK",
          }
        });
      }else
      if (res.message == constants.PASSWORD_PHRASE) {
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          width: 'auto', height: 'auto',
          data: {
            content1: constants.PASSWORD_PHRASE,
            button1Text: "OK",
          }
        });
      }
      else 
      if(res.message && res.message == 'Entered old password does not match'){
        const dialogRef = this.dialog.open(OpenDialogYesOrNo, {
          disableClose: true,
          width: 'auto', height: 'auto',
          data: {
            content1: constants.PASSWORD_ENTERED_WRONG,
            button1Text: "OK",
          }
        });
        dialogRef.afterClosed().subscribe(res => {
          this.updatePasswordForm.controls['oldPrd'].reset();
          this.currentPasswordString = "Re-enter current password"
        })
      }
    }

    )
  }


}
